import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import AuthLayout from '../layouts/AuthLayout';

interface PrivateRouteProps {
  title: string;
  children: JSX.Element;
}

export default function PrivateRoute({ title, children }: PrivateRouteProps) {
  const { signed } = useAuthContext();

  return signed ? <AuthLayout title={title}>{children}</AuthLayout> : <Navigate to="/login" />;
}
